import { Controller } from "@hotwired/stimulus"

const AUTO_RESOLVED_PLACEHOLDERS = ["参加者名", "インタビュー日時", "確定日時", "会場名", "会場郵便番号", "会場住所", "会場への道順", "謝礼金額"]

export default class extends Controller {
  static targets = ["preview", "input"]
  static values = { body: String }

  connect() {
    // NOTE: 案内状本文は rich-placeholder-editor の hidden field に書き込まれるため、
    //       その input イベントを listen して bodyValue を動的に更新する。
    this.bodyHidden = this.element.querySelector("[data-rich-placeholder-editor-target='hidden']")
    if (this.bodyHidden) {
      this.boundBodyUpdate = () => {
        this.bodyValue = this.bodyHidden.value
        this.render()
      }
      this.bodyHidden.addEventListener("input", this.boundBodyUpdate)
    }
    this.render()
  }

  disconnect() {
    if (this.bodyHidden && this.boundBodyUpdate) {
      this.bodyHidden.removeEventListener("input", this.boundBodyUpdate)
    }
  }

  update() {
    this.render()
  }

  render() {
    const values = {}
    this.inputTargets.forEach(input => {
      const name = input.dataset.placeholderName
      if (name) {
        values[name] = input.value
      }
    })

    // NOTE: body は rich エディタが生成した HTML を含むため、 escape せずに直挿入する。
    //       同一セッションのユーザーが自分の入力をプレビューする用途のため XSS の自爆は許容する。
    //       旧 plain text データの \n は <br> に変換する。
    let html = (this.bodyValue || "").replace(/\r?\n/g, "<br>")

    html = html.replace(/\{\{(.+?)\}\}/g, (_match, name) => {
      const value = values[name]
      if (value && value.trim() !== "") {
        return `<span class="bg-emerald-100 text-emerald-800 px-1 rounded">${this.escapeHtml(value)}</span>`
      }
      if (AUTO_RESOLVED_PLACEHOLDERS.includes(name)) {
        return `<span class="bg-sky-100 text-sky-800 px-1 rounded font-medium">{{${this.escapeHtml(name)}}}</span>`
      }
      return `<span class="bg-amber-100 text-amber-800 px-1 rounded font-medium">{{${this.escapeHtml(name)}}}</span>`
    })

    html = this.autoLinkUrls(html)

    this.previewTarget.innerHTML = html
  }

  autoLinkUrls(html) {
    const preserved = []
    let text = html.replace(/<a\b[^>]*>[\s\S]*?<\/a>/g, (m) => {
      preserved.push(m)
      return ` AUTOLINK${preserved.length - 1} `
    })
    text = text.replace(/https?:\/\/[^\s<>"'、,。　]+/g, (url) => {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color: #4f46e5; text-decoration: underline">${url}</a>`
    })
    return text.replace(/ AUTOLINK(\d+) /g, (_, i) => preserved[parseInt(i, 10)])
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
